<template>
  <div>
    <div @click="toggleDropdown" class="dropdown-toggle nav-item">一覧</div>
    <div v-if="isOpen" class="dropdown-menu">
      <router-link to="/muserTable" class="dropdown-item" @click="closeDropdown"
        >利用者一覧</router-link
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, defineProps } from "vue";
import { RouterLink } from "vue-router";
import CompanyService from "../Js/CompanyService";
const companyService = CompanyService; //会社情報、既にexport default new CompanyService();をしている。

const isOpen = ref(false);

const props = defineProps({
  isOpenMenu6: Boolean,
});

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const closeDropdown = () => {
  isOpen.value = false;
};

watch(
  () => props.isOpenMenu6,
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue == true) {
      isOpen.value = false;
    }
  }
);
</script>

<style scoped>
.dropdown-toggle {
  cursor: pointer;
  padding: 8px;
  background-color: #007bff;
  color: white;
}

.dropdown-menu {
  position: fixed;
  display: block;
  background-color: white;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  max-height: 50vh;
  overflow-y: auto;
  z-index: 9000 !important;
}

.dropdown-item {
  padding: 8px;
  display: block;
  color: black;
  text-decoration: none;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}
</style>
